import * as _ from 'lodash';

const detalleDefault = {

};

const mainDefault = {
  tipoDeServicio: '',
  departamento: '',
  ciudad: ''
};

const normalize = data => {
  const target = { ...data,
    categoria: {
      value: _.get(data, 'categoria.id') || '',
      label:
        `${_.get(data, 'categoria.codigo')} - ${_.get(
          data,
          'categoria.descripcion'
        )}` || ''
    }
  };
  
  return target;
};

const denormalize = data => {
  const target = {
    encriptado: data.encriptado,
    categoria: Number.parseInt(data.categoria.value, 10)
  };
  return target;
};

export { normalize, denormalize, detalleDefault, mainDefault };
